import { FONT } from './font';
import { LETTER_SPACING } from './letterSpacing';
import { LINE_HEIGHT } from './lineHeight';
import { TEXT } from './text';

export * from './icons';
export * from './font';

export const TYPOGRAPHY = {
  // Getter, not a property: setFonts() rebinds FONT after the brand resolves, and a plain
  // property would snapshot the Alto fonts at module load.
  get FONT() {
    return FONT;
  },
  LETTER_SPACING,
  LINE_HEIGHT,
  TEXT,
} as const;
